// validate user credentials

const J2VAuth = {};

J2VAuth.baseURL = "https://api.json2video.com/v2";

J2VAuth.login = async function (email, apikey) {
    try {
        var user = await this.sendGetRequestWithHeader(`${J2VAuth.baseURL}/account?email=${email}`, "x-api-key", apikey);
        // console.log("User: ", user);
    }
    catch (error) {
        this.logout();
        return {
            success: false,
            message: "Credentials could not be validated"
        };
    }

    if (user.success === true) {
        const credentials = {
            email: email,
            apiKey: apikey
        };
        localStorage.setItem("userCredentials", JSON.stringify(credentials));
        localStorage.setItem("userProfile", JSON.stringify({
            firstName: user.user?.first_name ?? null,
            lastName: user.user?.last_name ?? null,
            picture: user.user?.picture ?? null,
            plan: user.account?.plan ?? null,
            planInfo: user.account?.plan_info ?? null,
            quota: user.remaining_quota  ?? null
        }));
        return {
            success: true,
            message: "Credentials validated",
            data: user
        };
    }
    else {
        this.logout();
        return {
            success: false,
            message: "There was a problem signing in"
        };
    }
};

J2VAuth.logout = function () {
    localStorage.removeItem("userCredentials");
    localStorage.removeItem("userProfile");
};

J2VAuth.isSignedIn = function () {
    return localStorage.getItem("userCredentials") !== null;
};

J2VAuth.getUserProfile = function () {
    const userProfile = localStorage.getItem("userProfile");
    if (userProfile) {
        return JSON.parse(userProfile);
    }
    return null;
};

J2VAuth.getCredentials = function () {
    const userCredentials = localStorage.getItem("userCredentials");
    if (userCredentials) {
        return JSON.parse(userCredentials);
    }
    return null;
}

J2VAuth.refresh = async function () {
    const storedCredentials = localStorage.getItem("userCredentials");
    if (!storedCredentials) return false;

    const credentials = JSON.parse(storedCredentials);
    if (!credentials) return false;

    return await this.login(credentials.email, credentials.apiKey);
};

J2VAuth.redirectToLoginScreen = function () {
    window.location.href = "/login";
};

J2VAuth.sendGetRequestWithHeader = async function (url, headerName, headerValue) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.setRequestHeader(headerName, headerValue);

        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    resolve(response);
                } else {
                    reject('Error: ' + xhr.status);
                }
            }
        };

        xhr.send();
    });
}

export default J2VAuth;